/* Video promo board: muted autoplay, videos play one after another (no limit) with a pause between,
   unmute / replay / pause. Supports uploaded videos, YouTube (watch, youtu.be, Shorts, embed, live),
   Vimeo and direct video file links (.mp4 .webm .mov .m4v .ogg). */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function L(k, d) { var s = window.theme && window.theme.strings; return (s && s[k]) || d; }
  var scripts = {};
  function loadScript(src) {
    if (!scripts[src]) scripts[src] = new Promise(function (res, rej) {
      var s = document.createElement('script'); s.src = src; s.async = true;
      s.onload = function () { res(); }; s.onerror = rej; document.head.appendChild(s);
    });
    return scripts[src];
  }
  var ytReady = null;
  function loadYT() {
    if (window.YT && window.YT.Player) return Promise.resolve();
    if (!ytReady) ytReady = new Promise(function (res) {
      var prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () { if (prev) try { prev(); } catch (e) {} res(); };
      loadScript('https://www.youtube.com/iframe_api');
    });
    return ytReady;
  }
  function parse(url) {
    url = (url || '').trim(); if (!url) return null;
    if (!/^https?:\/\//i.test(url) && !/^\/\//.test(url)) url = 'https://' + url.replace(/^\/+/, '');
    var m;
    if ((m = url.match(/(?:youtube(?:-nocookie)?\.com\/(?:shorts|embed|live|v)\/|youtu\.be\/)([\w-]{11})/i)) ||
        (m = url.match(/youtube\.com\/.*[?&]v=([\w-]{11})/i))) {
      return { type: 'youtube', id: m[1], vertical: /\/shorts\//i.test(url) };
    }
    if ((m = url.match(/vimeo\.com\/(?:.*\/)?(\d{6,})/i))) return { type: 'vimeo', id: m[1], url: url };
    return { type: 'file', url: url };
  }
  /* Size an iframe so it covers the card like object-fit: cover */
  function cover(box, ratio) {
    function fit() {
      var w = box.clientWidth, h = box.clientHeight; if (!w || !h) return;
      var fw = w, fh = w / ratio;
      if (fh < h) { fh = h; fw = h * ratio; }
      box.style.setProperty('--fw', Math.ceil(fw) + 2 + 'px');
      box.style.setProperty('--fh', Math.ceil(fh) + 2 + 'px');
    }
    fit();
    if ('ResizeObserver' in window) new ResizeObserver(fit).observe(box); else window.addEventListener('resize', fit);
  }
  function fail(box, msg) { box.innerHTML = '<div class="pvideo__err">' + msg + '</div>'; }

  /* ---------- adapters: every slide exposes play / pause / restart / setMuted ---------- */
  function nativeAdapter(v, cb) {
    v.muted = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.loop = false; v.removeAttribute('controls');
    v.addEventListener('ended', cb.ended);
    v.addEventListener('error', cb.error);
    v.addEventListener('timeupdate', function () { if (v.duration) cb.progress(v.currentTime / v.duration); });
    return {
      play: function (muted, vol) { v.volume = (vol == null ? 5 : vol) / 100; v.muted = muted; if (v.ended) v.currentTime = 0; var p = v.play(); if (p && p.catch) p.catch(function () { if (!muted) { v.muted = true; v.play().catch(function () {}); } }); },
      pause: function () { v.pause(); },
      restart: function () { try { v.currentTime = 0; } catch (e) {} },
      setMuted: function (m) { v.muted = m; },
      setVolume: function (x) { v.volume = x / 100; }
    };
  }
  function fileAdapter(box, src, cb) {
    var v = document.createElement('video');
    v.preload = 'metadata'; v.muted = true; v.src = src; v.className = 'pvideo__media';
    box.appendChild(v);
    return nativeAdapter(v, cb);
  }
  function youtubeAdapter(box, info, cb) {
    var ratio = info.vertical ? 9 / 16 : 16 / 9;
    var host = document.createElement('div'); host.className = 'pvideo__frame'; box.appendChild(host);
    cover(box, ratio);
    var player = null, ready = false, want = null, muted = true, poll = null, level = 5;
    function tick() {
      clearInterval(poll);
      poll = setInterval(function () { try { var d = player.getDuration(); if (d) cb.progress(player.getCurrentTime() / d); } catch (e) {} }, 250);
    }
    loadYT().then(function () {
      player = new YT.Player(host, {
        videoId: info.id,
        playerVars: { autoplay: 0, mute: 1, controls: 0, playsinline: 1, rel: 0, modestbranding: 1, iv_load_policy: 3, fs: 0, disablekb: 1, loop: 0, origin: location.origin },
        events: {
          onReady: function () { ready = true; player.mute(); if (want) want(); want = null; },
          onStateChange: function (e) {
            if (e.data === 1) tick();
            if (e.data === 0) { clearInterval(poll); cb.progress(1); cb.ended(); }
          },
          onError: function () { clearInterval(poll); fail(box, L('videoBlocked', 'This video can’t be played here. Skipping…')); cb.error(); }
        }
      });
    });
    function when(fn) { if (ready) fn(); else want = fn; }
    return {
      play: function (m, vol) { muted = m; if (vol != null) level = vol; when(function () { player.setVolume(level); if (muted) player.mute(); else player.unMute(); player.playVideo(); }); },
      pause: function () { clearInterval(poll); when(function () { player.pauseVideo(); }); },
      restart: function () { when(function () { player.seekTo(0, true); }); },
      setMuted: function (m) { muted = m; when(function () { if (m) player.mute(); else { player.setVolume(level); player.unMute(); } }); },
      setVolume: function (x) { level = x; when(function () { player.setVolume(x); }); }
    };
  }
  function vimeoAdapter(box, info, cb) {
    var ifr = document.createElement('iframe');
    ifr.src = 'https://player.vimeo.com/video/' + info.id + '?muted=1&autoplay=0&controls=0&playsinline=1&dnt=1&title=0&byline=0&portrait=0';
    ifr.allow = 'autoplay; fullscreen; picture-in-picture'; ifr.setAttribute('allowfullscreen', '');
    box.appendChild(ifr);
    cover(box, 16 / 9);
    var p = null, q = [], level = 5;
    loadScript('https://player.vimeo.com/api/player.js').then(function () {
      p = new Vimeo.Player(ifr);
      p.getVideoWidth().then(function (w) { return p.getVideoHeight().then(function (h) { if (w && h) cover(box, w / h); }); }).catch(function () {});
      p.on('ended', function () { cb.progress(1); cb.ended(); });
      p.on('timeupdate', function (d) { if (d && d.percent != null) cb.progress(d.percent); });
      p.on('error', function () { cb.error(); });
      q.forEach(function (f) { f(); }); q = [];
    }).catch(function () { cb.error(); });
    function when(f) { if (p) f(); else q.push(f); }
    return {
      play: function (m, vol) { if (vol != null) level = vol; when(function () { p.setVolume(m ? 0 : level / 100).catch(function () {}); p.setMuted(m).catch(function () {}); p.play().catch(function () { p.setMuted(true); p.play().catch(function () {}); }); }); },
      pause: function () { when(function () { p.pause().catch(function () {}); }); },
      restart: function () { when(function () { p.setCurrentTime(0).catch(function () {}); }); },
      setMuted: function (m) { when(function () { p.setMuted(m).catch(function () {}); if (!m) p.setVolume(level / 100).catch(function () {}); }); },
      setVolume: function (x) { level = x; when(function () { p.setVolume(x / 100).catch(function () {}); }); }
    };
  }
  var noop = { play: function () {}, pause: function () {}, restart: function () {}, setMuted: function () {}, setVolume: function () {} };

  /* ---------- the board ---------- */
  function init(root) {
    if (root._pv) return; root._pv = true;
    var slides = [].slice.call(root.querySelectorAll('[data-slide]'));
    var dots = [].slice.call(root.querySelectorAll('.pvideo__dot'));
    var nextBox = root.querySelector('[data-next]'), countEl = root.querySelector('[data-count]');
    var btnMute = root.querySelector('[data-mute]'), btnPlay = root.querySelector('[data-play]'), btnReplay = root.querySelector('[data-replay]');
    var gap = parseInt(root.getAttribute('data-gap') || '5', 10);
    var idx = 0, muted = true, paused = false, visible = false, timer = null, remaining = 0, started = false;
    var volRange = root.querySelector('[data-volume]');
    var vol = volRange ? parseInt(volRange.value, 10) : 5; if (isNaN(vol)) vol = 5;
    var players = [], watch = null;

    function setDot(k, p) { var d = dots[k]; if (d) d.style.setProperty('--p', p); }
    function getPlayer(k) {
      if (players[k]) return players[k];
      var s = slides[k], cb = {
        ended: function () { if (k === idx) schedule(); },
        error: function () { if (k === idx) schedule(true); },
        progress: function (p) { if (k === idx) { if (p > 0) clearTimeout(watch); setDot(k, p); } }
      };
      var v = s.querySelector('video'), ext = s.querySelector('.pvideo__ext[data-src]'), pl = null;
      if (v) pl = nativeAdapter(v, cb);
      else if (ext) {
        var info = parse(ext.getAttribute('data-src'));
        if (!info) pl = null;
        else if (info.type === 'youtube') pl = youtubeAdapter(ext, info, cb);
        else if (info.type === 'vimeo') pl = vimeoAdapter(ext, info, cb);
        else pl = fileAdapter(ext, info.url, cb);
      }
      players[k] = pl || noop; players[k].isMedia = !!pl;
      return players[k];
    }
    function show(i) {
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); if (k !== i && players[k]) players[k].pause(); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.style.setProperty('--p', 0); });
      idx = i;
      /* warm up the next slide so it starts instantly */
      if (slides.length > 1) getPlayer((i + 1) % slides.length);
    }
    function play() {
      started = true;
      var pl = getPlayer(idx);
      if (!pl.isMedia) { schedule(); return; }  /* slide without a video: wait, then move on */
      pl.play(muted, vol);
      /* Watchdog: if a video can't start (blocked embed, bad link, offline), skip it instead of freezing the board */
      clearTimeout(watch);
      var k = idx;
      watch = setTimeout(function () { if (k === idx && !paused && visible && !timer) schedule(true); }, 12000);
    }
    function stopTimer() { clearTimeout(watch); clearInterval(timer); timer = null; if (nextBox) nextBox.hidden = true; }
    function schedule(quick) {
      stopTimer();
      remaining = quick ? Math.min(gap, 2) : gap;
      if (remaining <= 0) { advance(); return; }
      if (nextBox && slides.length > 1) { countEl.textContent = remaining; nextBox.hidden = false; }
      timer = setInterval(function () {
        if (paused || !visible) return;
        remaining -= 1;
        if (countEl) countEl.textContent = Math.max(remaining, 0);
        if (remaining <= 0) { stopTimer(); advance(); }
      }, 1000);
    }
    function advance() {
      var n = (idx + 1) % slides.length;
      show(n); getPlayer(n).restart(); play();
    }

    /* Sound: only one player on the page can be unmuted at a time */
    function setMute(m) {
      muted = m;
      getPlayer(idx).setMuted(muted);
      if (!muted) {
        getPlayer(idx).setVolume(vol);
        if (!paused && !timer) getPlayer(idx).play(false, vol);
        document.dispatchEvent(new CustomEvent('pvideo:unmute', { detail: root }));
      }
      if (btnMute) { btnMute.setAttribute('aria-pressed', muted ? 'false' : 'true'); btnMute.setAttribute('aria-label', muted ? L('unmute', 'Unmute') : L('mute', 'Mute')); }
      root.classList.toggle('is-unmuted', !muted);
    }
    document.addEventListener('pvideo:unmute', function (e) { if (e.detail !== root && !muted) setMute(true); });
    if (btnMute) btnMute.addEventListener('click', function () {
      if (muted && vol === 0) { vol = 5; if (volRange) volRange.value = 5; }
      setMute(!muted);
    });
    if (volRange) {
      var paint = function () { volRange.style.setProperty('--v', vol + '%'); };
      paint();
      volRange.addEventListener('input', function () {
        vol = parseInt(volRange.value, 10) || 0; paint();
        getPlayer(idx).setVolume(vol);
        if (vol === 0 && !muted) setMute(true);
        else if (vol > 0 && muted) setMute(false);
      });
    }
    if (btnPlay) btnPlay.addEventListener('click', function () {
      paused = !paused;
      btnPlay.setAttribute('aria-pressed', paused ? 'false' : 'true');
      btnPlay.setAttribute('aria-label', paused ? L('play', 'Play') : L('pause', 'Pause'));
      if (paused) { clearTimeout(watch); getPlayer(idx).pause(); } else if (!timer) play();
    });
    if (btnReplay) btnReplay.addEventListener('click', function () {
      stopTimer(); getPlayer(idx).restart(); setDot(idx, 0);
      paused = false; if (btnPlay) { btnPlay.setAttribute('aria-pressed', 'true'); btnPlay.setAttribute('aria-label', L('pause', 'Pause')); }
      play();
    });

    show(0); getPlayer(0);
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (calm) { paused = true; if (btnPlay) btnPlay.setAttribute('aria-pressed', 'false'); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        visible = en[0].isIntersecting;
        if (visible && !paused && !timer) play();
        else if (!visible && started) getPlayer(idx).pause();
      }, { threshold: 0.35 }).observe(root);
    } else { visible = true; if (!paused) play(); }
  }

  function initRow(row) {
    if (row._pr) return; row._pr = true;
    var track = row.querySelector('[data-track]'), prev = row.querySelector('[data-prev]'), next = row.querySelector('[data-next-btn]');
    function upd() { if (!track || !prev || !next) return; prev.disabled = track.scrollLeft < 4; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
    function go(d) { track.scrollBy({ left: d * track.clientWidth * 0.8, behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    if (track) { track.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd(); }
  }
  function boot() { [].forEach.call(document.querySelectorAll('[data-pvideo]'), init); [].forEach.call(document.querySelectorAll('[data-prow]'), initRow); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
